import { useEffect, useMemo, useState } from "react";

/** A very simple local storage hook.
 * DO NOT ADD any other functionality here.
 * This hook should only read/write to store on
 * read/write of the state.
 * For more complex cases (like window storage event
 * support) please use useLocalStorage from @uidotdev/usehooks
 * */
export default function useSimpleLocalStorage<T>(key: string, initialValue: T) {
  const item = useMemo(() => localStorage.getItem(key), [key]);
  const [value, setValue] = useState<T>(item ? JSON.parse(item) : initialValue);

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue] as const;
}
